import { useMemo } from "react";
import { useContractTypes, useCustomRolesDB } from "./useSupabase";

export function useReviewLabels() {
  const { contractTypes } = useContractTypes();
  const { roles } = useCustomRolesDB();

  const getContractTypeLabel = useMemo(() => {
    return (value: string | null | undefined) => {
      if (!value) return "Not specified";
      const type = contractTypes.find((t) => t.value === value);
      return type?.name || value;
    };
  }, [contractTypes]);

  const getRoleLabel = useMemo(() => {
    return (roleKey: string | null | undefined) => {
      if (!roleKey) return "Not specified";
      const role = roles.find((r) => r.role_key === roleKey);
      return role?.name || roleKey;
    };
  }, [roles]);

  return { getContractTypeLabel, getRoleLabel };
}
